const $ = jQuery.noConflict();

'use strict';
const Products = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domProject: $('.js-projects__content-wrapper-box'),
	$domLoadMoreWrapp: $('.js-projects__load-more-wrapp'),
	$domLoadMoreButton: $('.js-projects__load-more'),

	showClassButton: 'button-active',
	showProductClass: 'product-show',

	/** @description Initialize */
	init: function() {
		this.loadMoreProductsButton();
		this.showAndHideProducts();
		this.loadMoreProducts();
	},

	loadMoreProductsButton: function() {
		const projects = Products.$domProject;

		if(projects.length > 6) {
			Products.$domLoadMoreWrapp.addClass(Products.showClassButton);
		} else {
			Products.$domLoadMoreWrapp.removeClass(Products.showClassButton);
		}
	},

	showAndHideProducts: function() {
		const projects = Products.$domProject;

		projects.each(function(index) {
			if(index < 6) {
				$(this).addClass(Products.showProductClass);
			} else {
				return false;
			}
		});
	},

	loadMoreProducts: function() {
		Products.$domLoadMoreButton.on('click', function() {
			const projects = Products.$domProject;
			projects.addClass(Products.showProductClass);
			Products.$domLoadMoreWrapp.removeClass(Products.showClassButton);
		});
	},
};

export default Products;
